import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import ReactDOM from 'react-dom';
class ScrollAnimate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      offsetReached: false,
    }
    this.handleScroll = this.handleScroll.bind(this);
  }
  componentWillMount() {
     window.addEventListener('scroll', this.handleScroll);
  }
  componentWillUnmount() {
     window.removeEventListener('scroll', this.handleScroll);
  }
  handleScroll(event) {
    const { offsetHeight } = this.props;
    const height = event.srcElement.body.scrollTop;
    if ( height > offsetHeight ) {
      this.setState({offsetReached: true});
    }
  }
  render() {
    const classes = this.state.offsetReached ?
      `${this.props.animateClass}-true` : `${this.props.animateClass}-false`;
    return (
      <div className={`animate-wrapper ${classes}`}>
        {React.cloneElement(this.props.children, ...this.state)}
      </div>
    );
  }
}
export default ScrollAnimate;



// WEBPACK FOOTER //
// ./src/components/ScrollAnimate.js